<span [ngClass]="class" [hidden]="!text">{{ text }}
  @if (reason) {
    <i class="fas fa-info-circle align-middle" style="padding-left: 5px; font-size: 13px;"
      [ngbPopover]="reasonPopContent" triggers="mouseenter:mouseleave" container="body"></i>
  }
</span>
<ng-template #reasonPopContent>
  <div class="popoverCustomWidth">{{ reason }}</div>
</ng-template>
